'use strict';

define('vb/private/stateManagement/router/vbParamRootRouter',[
  'vb/private/stateManagement/router/vbRootRouter',
  'vb/private/stateManagement/router/urlParamAdapter',
  'vb/private/stateManagement/routerUtils',
], (VbRootRouter, UrlParamAdapter, RouterUtils) => {
  class VbParamRootRouter extends VbRootRouter {
    /**
     * @param {string} key
     * @param {UrlParamAdapter} [urlAdapter=UrlPathAdapter] Default adapter is the UrlParamAdapter
     */
    constructor(key, urlAdapter = new UrlParamAdapter()) {
      super(key, urlAdapter);
    }

    /**
     * Updates the application state by adding router query parameters to the URL and
     * pushing a new state to the browser history.
     *
     * @param {string|null} pagePath - The new page path to set in the browser's history.
     * @param {boolean} [replace=false] - Whether to replace the current state in the browser's history
     * instead of pushing a new one.
     * @returns {Promise<void>} A promise that resolves when the state has been updated.
     */
    updateState(pagePath, replace) {
      return Promise.resolve().then(() => {
        const params = RouterUtils.buildSearch(this);
        this.history.addRouterQueryParameters(params);

        return super.updateState(pagePath, replace);
      });
    }
  }

  return VbParamRootRouter;
});

